export default __webpack_public_path__ + "static/cruiselogo_vv-9dc08ae1411e1b29de96a443f845299d.png";